/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IOpProcedureOrder } from 'app/shared/model/op-procedure-order.model';
import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';
import { IDentalExamAndTreatment } from 'app/shared/model/dental-exam-and-treatment.model';
import { IDentalMouthItem } from 'app/shared/model/dental-mouth-item.model';
import { IDentalSurface } from 'app/shared/model/dental-surface.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';

export interface IOpProcedureOrderItem {
  id?: string;
  active?: boolean | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  lastUpdated?: number | null;
  cursor?: number | null;
  totalCost?: number | null;
  notes?: string | null;
  orderStatus?: keyof typeof OrderStatus | null;
  procedureStatus?: keyof typeof ProcedureStatus | null;
  order?: IOpProcedureOrder;
  procedure?: IHospitalProcedure | null;
  exam?: IDentalExamAndTreatment | null;
  tooth?: IDentalMouthItem | null;
  surface?: IDentalSurface | null;
}

export const defaultValue: Readonly<IOpProcedureOrderItem> = {
  active: false,
};
